// extracted by mini-css-extract-plugin
module.exports = {"container":"flag-ticker_container__EYOMo","flags":"flag-ticker_flags__6NSQZ","flag":"flag-ticker_flag__q7BuM"};